import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import SearchIcon from "@material-ui/icons/Search";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import MenuIcon from "@material-ui/icons/Menu";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import DoneAllIcon from '@material-ui/icons/DoneAll';

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../services/api";
import { handleGenericUpdate } from "../../../core/utils/handleGeneric";
import { ADMINISTRACION, ADMINISTRADOR } from "../../../core/utils/roles.constants";
import BotonGenerico from "../../../components/Button/Button";
import ConfirmDialog from "../../../components/Dialogs/ConfirmDialog";
import OrdenServicios from "./adicionales/ordenServicios.jsx";
import CrearOrden from "./adicionales/createOrden";
import { useAuth } from "../../../contexts/AuthContext";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  leftButtonContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  leftButton: {
    display: "flex",
    alignItems: "center",
    textTransform: "none",
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  rightActionsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  searchField: {
    marginRight: theme.spacing(2),
    width: "200px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginBottom: theme.spacing(1),
    },
  },
  iconButtonsContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  errorIcon: {
    color: "green",
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButtons: {
    justifyContent: "center",
  },
  greenButton: {
    color: "green",
    borderColor: "green",
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
  },
  menuIconButton: {
    color: theme.palette.primary.main,
  },
  menuItemIcon: {
    marginRight: theme.spacing(1),
  },
  greenIcon: {
    color: "green",
  },
  dateRangeFormContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  dateRangeFields: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      minWidth: "150px", // Asegura un ancho mínimo para alineación
    },
  },
  dateRangeButton: {
    marginTop: theme.spacing(2),
    alignSelf: "center", // Centrar el botón
  },
  greenBackg: {
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  dialogContentWide: {
    minWidth: "500px", // Añade un ancho mínimo de 500px
    maxWidth: "1000px", // Ajusta a 700px para más espacio
    padding: theme.spacing(3), // Más espacio interno para mejor legibilidad
  },
  dialogTitleCols: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  // Para evitar el solapamiento del texto
  dialogTitleText: {
    marginRight: theme.spacing(3), // Separa el texto del ícono de cerrar
  },
}));

const Rendiciones = () => {
  const { getUser } = useAuth();
  const user = getUser();

  const classes = useStyles();
  const [dataEvents, setDataEvents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showHiddenRecords, setShowHiddenRecords] = useState(false);
  const [showDateRangeForm, setShowDateRangeForm] = useState(false);
  const [area, setArea] = useState("");
  const [status, setStatus] = useState("");

  // ------------------ Estados de filtros ------------------
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [sectorFiltrado, setSectorFiltrado] = useState([]);

  const [os, setOS] = useState(null);
  const [listaSectores, setListaSectores] = useState([]);

  const [listaPersonal, setListaPersonal] = useState([]);
  const [tipoOrden, setTipoOrden] = useState("");

  const [openForm, setOpenForm] = useState(false);
  const [columnConfigOpen, setColumnConfigOpen] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    Estado: true,
    Tipo: true,
    NroReferencia: true,
    Fecha: true,
    Sector: true,
    Importe: true,
    Opciones: true,
  });

  useEffect(() => {
    // Obtener de base de datos por API
    const fetchData = async () => {
      try {
        const [ordenesServiciosResponse, comprobantesOSResponse, ordenesCompraResponse, sectoresResponse, itemsRequisicionesResponse, proveedoresResponse] = await Promise.all([
          api.ordenesServicios.getAll(),
          api.comprobantesOS.getAll(),
          api.ordenesCompra.getAll(),
          api.sectores.getAll(),
          api.itemsRequisiciones.getAll(),
          api.proveedores.getAll(),
        ]);

        setSectorFiltrado(sectoresResponse.filter(s => s.oculto === 0));
        setListaSectores(sectoresResponse);
        setListaPersonal(proveedoresResponse.reverse());

        // Unificar estadoOS (ordenesServicios) y idestado (ordenesCompra) en estado
        const servicios = ordenesServiciosResponse
          .map(item => {
            const comprobante = comprobantesOSResponse.find(comp => comp.idOS === item.idOS);
            const sector = sectoresResponse.find(sec => sec.IdSector === item.idSector);
            if (!comprobante) return null; // Si no tiene comprobante, quitar de servicios
            return {
              ...item,
              estado: comprobante.estado,
              tipo: 'Orden de Servicios',
              nroReferencia: item.idOS || 'N/A',
              fecha: comprobante.fechaComprobante || 'N/A',
              sector: sector ? sector.Nombre : 'N/A',
              importe: (item.moneda === 'USD' ? item.importeTotal * item.tipoDeCambio : item.importeTotal),
            };
          })
          .filter(item => item !== null);

        const itemsRequisiciones = itemsRequisicionesResponse.reduce((map, item) => {
          const id = item.idRequision;
          if (!map[id]) map[id] = [];
          map[id].push(item);
          return map;
        }, {});

        // IDs de requisiciones desde OC
        const requisicionIds = ordenesCompraResponse.map(oc => oc.IdRequisicion);

        // Obtener requisiciones por ID
        const requisiciones = await Promise.all(
          requisicionIds.map(id => api.requisiciones.getById(id))
        );

        // Formatear requisiciones para incluir Items
        const requisicionesFormateadas = requisiciones.map((req) => {
          const id = req.idRequision;

          const itemsReqList = itemsRequisiciones[id] || [];

          const itemsConDetalle = itemsReqList.map(itemReq => {

            const cantidad = parseFloat(itemReq.cantidad) || 0;
            const importeUnitario = parseFloat(itemReq.importeUnitario) || 0;
            const subtotal = importeUnitario * cantidad;

            return {
              ...itemReq,
              // nombreItem: item.nombre || '',
              nombreItem: itemReq.itemName || '',
              importeUnitario,
              cantidad,
              subtotal,
            };
          }).filter(Boolean);

          const totalImporte = itemsConDetalle.reduce((acc, item) => acc + item.subtotal, 0);

          return {
            ...req,
            ItemsRequisicion: itemsConDetalle,
            Importe: totalImporte,
          };
        });

        const compras = ordenesCompraResponse.map((item, index) => {
          const sector = sectoresResponse.find(sec => sec.IdSector === item.IdSector);
          const requisicion = requisicionesFormateadas.find(req => req.idRequision === item.IdRequisicion);
          return {
            ...item,
            estado: item.IdEstado,
            tipo: 'Orden de Compra',
            nroReferencia: item.NroOrdenDeCompra || 'N/A',
            fecha: item.Fecha_Adjunto || 'N/A',
            sector: sector ? sector.Nombre : 'N/A',
            importe: requisicion.Importe,
            requisicion: requisicion || null,
          };
        });

        const data = [
          ...servicios,
          ...compras,
        ].filter(r => {
          const sectores = Array.isArray(user.sectores) && user.sectores.length > 0
            ? user.sectores.map(Number) : [Number(user.IdSector)];
          return user.es_admin === ADMINISTRADOR || user.es_admin === ADMINISTRACION || sectores.includes(Number(r.idSector));
        });

        setDataEvents(data);
        setFilteredEvents(data);
      } catch (error) {
        console.error("Error al cargar ordenes de compra:", error.message);
      }
    };

    fetchData();

    // setDataEvents(mockData);
    // setFilteredEvents(mockData);
  }, []);

  useEffect(() => {
    let temp = [...dataEvents];

    // Filtrar por oculto
    //temp = temp.filter((row) => showHiddenRecords ? row.oculto : !row.oculto);

    // Filtrar por sector
    if (selectedSector) {
      temp = temp.filter((row) => row.idSector === selectedSector || row.IdSector === selectedSector);
    }

    // Filtrar por rango de fechas
    if (startDate) {
      temp = temp.filter((row) => new Date(row.fecha) >= new Date(startDate));
    }
    if (endDate) {
      temp = temp.filter((row) => new Date(row.fecha) <= new Date(endDate));
    }

    // Filtro de búsqueda
    if (searchText) {
      const text = searchText.toLowerCase();
      temp = temp.filter((event) =>
        Object.values(event).some(
          (value) =>
            value !== null && value !== undefined && String(value).toLowerCase().includes(text)
        )
      );
    }

    setFilteredEvents(temp);
    setPage(0);
  }, [dataEvents, searchText, selectedSector, selectedStatus, startDate, endDate, showHiddenRecords]);

  const handleOpenForm = (row, index) => {
    setSelectedRow(row);
    setOpenForm(true);
  }

  const handleCloseForm = () => {
    setSelectedRow(null);
    setOpenForm(false);
  }

  const handleSuccess = async (updatedOrderData) => {
    // Actualizar solo la orden específica editada
    try {
      if (!selectedRow || !updatedOrderData) {
        console.warn('No hay datos de orden actualizada');
        return;
      }

      // Obtener los datos actualizados de la orden de servicio específica
      const [ordenActualizada] = await Promise.all([
        api.ordenesServicios.getById(selectedRow.idOS)
      ]);

      // Obtener el comprobante y sector actualizados
      const [comprobante, sector] = await Promise.all([
        api.comprobantesOS.getAll().then(comp => comp.find(c => c.idOS === selectedRow.idOS)),
        api.sectores.getAll().then(sectores => sectores.find(s => s.IdSector === ordenActualizada.idSector))
      ]);

      // Crear el objeto de orden actualizada
      const ordenActualizadaCompleta = {
        ...ordenActualizada,
        estado: comprobante?.estado || selectedRow.estado,
        tipo: 'Orden de Servicios',
        nroReferencia: ordenActualizada.idOS || 'N/A',
        fecha: comprobante?.fechaComprobante || selectedRow.fecha,
        sector: sector?.Nombre || selectedRow.sector,
        importe: (ordenActualizada.moneda === 'USD'
          ? ordenActualizada.importeTotal * ordenActualizada.tipoDeCambio
          : ordenActualizada.importeTotal) || selectedRow.importe,
      };

      // Actualizar solo la fila específica en los datos existentes
      const updateData = (data) => {
        return data.map(item => {
          // Si es la orden de servicios que se editó, reemplazarla
          if (item.tipo === 'Orden de Servicios' && item.idOS === selectedRow.idOS) {
            return ordenActualizadaCompleta;
          }
          // Mantener el resto igual
          return item;
        });
      };

      // Actualizar ambos estados
      setDataEvents(prevData => updateData(prevData));
      setFilteredEvents(prevData => updateData(prevData));

      // Cerrar el formulario
      handleCloseForm();

      console.log('Orden actualizada exitosamente:', ordenActualizadaCompleta);
    } catch (error) {
      console.error('Error al actualizar la orden:', error);
      // En caso de error, mantener los datos como estaban
    }
  };

  const handleSearchChange = (event) => {
    const text = event.target.value.toLowerCase();
    setSearchText(text);
    const filtered = dataEvents.filter((event) =>
      Object.values(event).some((value) =>
        value != null &&
        value.toString().toLowerCase().includes(text)
      )
    );
    setFilteredEvents(filtered);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (rowIndex) => {
    setSelectedRow(rowIndex);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleHideRecord = () => {
    if (selectedRow !== null) {
      const newEvents = filteredEvents.map((row, index) =>
        index === selectedRow ? { ...row, hidden: true } : row
      );
      setFilteredEvents(newEvents);
      setDataEvents(newEvents);
      handleCloseDialog();
    }
  };

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleHiddenRecords = () => {
    setShowHiddenRecords((prev) => !prev);
    handleMenuClose();
  };

  const exportToCSV = () => {
    const csvData = filteredEvents.map((row) => Object.values(row).join(","));
    const csvContent = `data:text/csv;charset=utf-8,${[
      "Estado,Fecha,Concepto,Sector,Importe,Tipo",
    ].join(",")}\n${csvData.join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "table_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleMenuClose();
  };

  // const renderEstadoIcon = (estado) => {
  //   switch (estado) {
  //     case 1:
  //       return <HourglassEmptyIcon style={{ color: "orange" }} />;
  //     case 2:
  //       return <HourglassEmptyIcon style={{ color: "orange" }} />;
  //     case 3:
  //       return <CheckCircleIcon style={{ color: "green" }} />;
  //     case 4:
  //       return <CancelIcon style={{ color: "red" }} />;
  //     case 5:
  //       return <HourglassEmptyIcon style={{ color: "orange" }} />;
  //     case 'Firmado':
  //       return <CheckCircleIcon style={{ color: "green" }} />;
  //     case 'Pendiente de pago':
  //       return <CancelIcon style={{ color: "red" }} />;
  //     default:
  //       return null;
  //   }
  // };

  const renderEstadoIcon = (estado) => {
    const estadoColor = {
      1: "orange",
      2: "orange",
      3: "green",
      4: "red",
      5: "blue",
      'Firmado': "green",
      'Pendiente de pago': "red",
    };

    const estadoTooltip = {
      1: "Borrador",
      2: "Enviado a aprobar",
      3: "Aprobado",
      4: "Cancelado",
      5: "Completado",
      'Firmado': "Firmado",
      'Pendiente de pago': "Pendiente de pago",
    };

    const color = estadoColor[estado];
    const tooltipText = estadoTooltip[estado];
    if (!color || !tooltipText) return null;

    let Icon;

    switch (estado) {
      case 3: // Aprobado
        Icon = CheckCircleIcon;
        break;
      case 5: // Completado
        Icon = DoneAllIcon; // distinto icono
        break;
      case 4: // Cancelado
        Icon = CancelIcon;
        break;
      case 'Firmado':
        Icon = CheckCircleIcon;
        break;
      case 'Pendiente de pago':
        Icon = CancelIcon;
        break;
      default: // Borrador, Enviado a aprobar
        Icon = HourglassEmptyIcon;
        break;
    }

    return (
      <Tooltip title={<span style={{ fontSize: "0.8rem" }}>{tooltipText}</span>} arrow>
        <Icon style={{ color }} />
      </Tooltip>
    );
  };

  const handleDateRangeClick = () => {
    setShowDateRangeForm(!showDateRangeForm);
  };

  const handleAreaChange = (event) => {
    setArea(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleApply = () => {
    setShowDateRangeForm(false);
  };

  const handleColumnConfigOpen = () => setColumnConfigOpen(true);
  const handleColumnConfigClose = () => setColumnConfigOpen(false);

  const handleColumnVisibilityChange = (column) => {
    setVisibleColumns((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  const saveColumnConfiguration = () => {
    handleColumnConfigClose();
    // Aquí podrías agregar lógica adicional para guardar configuraciones si es necesario
  };

  // Filtra y ordena los rows por fecha descendente
  const visibleRows = filteredEvents
    .filter((row) => showHiddenRecords || !row.hidden)
    .sort((a, b) => {
      // Maneja valores de fecha inválidos o 'N/A'
      const dateA = a.fecha && a.fecha !== 'N/A' ? new Date(a.fecha) : new Date(0);
      const dateB = b.fecha && b.fecha !== 'N/A' ? new Date(b.fecha) : new Date(0);

      // Verifica si las fechas son válidas
      const isValidDateA = !isNaN(dateA.getTime()) && a.fecha !== 'N/A';
      const isValidDateB = !isNaN(dateB.getTime()) && b.fecha !== 'N/A';

      // Si ambas fechas son válidas, ordena por fecha
      if (isValidDateA && isValidDateB) {
        return dateB - dateA; // Orden descendente (más reciente primero)
      }

      // Si solo una fecha es válida, pon la válida primero
      if (isValidDateA && !isValidDateB) return -1;
      if (!isValidDateA && isValidDateB) return 1;

      // Si ninguna fecha es válida, mantén el orden original
      return 0;
    });

  return (
    <div>
      <div className={classes.headerContainer}>
        <div className={classes.leftButtonContainer}>
          {/* <BotonGenerico
            tipo="nuevo"
            text="Nuevo"
            onClick={handleOpenForm}
          /> */}
          {/* <IngresarComprobanteModal open={openForm} onClose={handleCloseForm} /> */}
          <CrearOrden
            open={openForm && selectedRow?.tipo === 'Orden de Compra'}
            onClose={handleCloseForm}
            tipoOrden={tipoOrden}
            ordenDeCompra={selectedRow}
            sectorParams={sectorFiltrado}
          />

          <OrdenServicios
            open={openForm && selectedRow?.tipo === 'Orden de Servicios'}
            onClose={handleCloseForm}
            onSuccess={handleSuccess}
            osDetails={selectedRow}
            listaPersonal={listaPersonal}
            listaSector={listaSectores}
            usuarioLocal={user}
          />

        </div>
        <div className={classes.rightActionsContainer}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Buscar"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div className={classes.iconButtonsContainer}>
            <IconButton color="primary" onClick={handleDateRangeClick}>
              {showDateRangeForm ? <EventBusyIcon /> : <DateRangeIcon />}
            </IconButton>
            <IconButton
              className={classes.menuIconButton}
              onClick={handleMenuOpen}
            >
              <MenuIcon className={classes.greenIcon} />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              keepMounted
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={toggleHiddenRecords}>
                <VisibilityOffIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Ver registros Ocultos
              </MenuItem>
              <MenuItem onClick={exportToCSV}>
                <RestorePageIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Exportar Registros
              </MenuItem>
              <MenuItem onClick={handleColumnConfigOpen}>
                <ViewCompactIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Configurar Columnas
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      {
        showDateRangeForm && (
          <div className={classes.dateRangeFormContainer}>
            <div className={classes.dateRangeFields}>
              <InputLabel>Desde:</InputLabel>
              <TextField variant="outlined" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <InputLabel>Hasta:</InputLabel>
              <TextField variant="outlined" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              <FormControl variant="outlined">
                <InputLabel>Sectores</InputLabel>
                <Select value={selectedSector} onChange={(e) => setSelectedSector(Number(e.target.value))}>
                  <MenuItem value="">Todos</MenuItem>
                  {sectorFiltrado.filter(s => s.oculto === 0).map((s) => <MenuItem key={s.IdSector} value={s.IdSector}>{s.Nombre}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
            <BotonGenerico color="primary" onClick={() => { setStartDate(""); setEndDate(""); setSelectedSector(""); setSelectedStatus(""); }} text="Borrar filtros" />
          </div>
        )
      }

      <Dialog
        open={columnConfigOpen}
        onClose={handleColumnConfigClose}
        classes={{ paper: classes.dialogContentWide }}
        maxWidth="lg"
      >
        <DialogTitle className={classes.dialogTitleCols}>
          Configurar Columnas
          <IconButton
            onClick={handleColumnConfigClose}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {Object.keys(visibleColumns).map((column) => (
            <div key={column} style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={visibleColumns[column]}
                onChange={() => handleColumnVisibilityChange(column)}
              />
              <Typography>{column}</Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {visibleColumns.Estado && (
                <TableCell>Estado</TableCell>
              )}
              {visibleColumns.Tipo && (
                <TableCell align="center">Tipo</TableCell>
              )}
              {visibleColumns.NroReferencia && (
                <TableCell align="center">Nro de referencia</TableCell>
              )}
              {visibleColumns.Fecha && (
                <TableCell align="center">Fecha</TableCell>
              )}
              {visibleColumns.Sector && (
                <TableCell align="center">Sector</TableCell>
              )}
              {visibleColumns.Importe && (
                <TableCell align="center">Importe total</TableCell>
              )}
              <TableCell align="center">Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.length > 0 ? (
              visibleRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={`item-${index}`}>
                    {visibleColumns.Estado && (
                      <TableCell>{renderEstadoIcon(row.estado)}</TableCell>
                    )}
                    {visibleColumns.Tipo && (
                      <TableCell align="center">{row.tipo}</TableCell>
                    )}
                    {visibleColumns.NroReferencia && (
                      <TableCell align="center">{row.nroReferencia}</TableCell>
                    )}
                    {visibleColumns.Fecha && (
                      <TableCell align="center">{row.fecha}</TableCell>
                    )}
                    {visibleColumns.Sector && (
                      <TableCell align="center">{row.sector}</TableCell>
                    )}
                    {visibleColumns.Importe && (
                      <TableCell align="center">$ {row.importe}</TableCell>
                    )}
                    <TableCell align="center">
                      {/* <IconButton>
                      <SearchIcon color="primary" />
                    </IconButton> */}
                      <IconButton
                        onClick={() => {
                          handleOpenForm(row, index)
                          // console.log(`Editando ${row.tipo} ${row.nroReferencia}`);
                          setTipoOrden(`Editando ${row.tipo} ${row.nroReferencia}`);
                        }}
                        className={classes.greenButton}
                      >
                        <SearchIcon color="primary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length} align="center">
                  No hay rendiciones para mostrar
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredEvents.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página"
      />

      <ConfirmDialog
        open={open}
        onClose={handleCloseDialog}
        onConfirm={() =>
          handleGenericUpdate({
            selectedItem: selectedRow,
            data: filteredEvents,
            setData: (newData) => {
              setFilteredEvents(newData);
              setDataEvents(newData);
            },
            apiUpdateFunction: api.comprobantesOS.update,
            idField: "IdComprobante",
            updatePayload: { oculto: true },
            closeDialog: handleCloseDialog,
          })
        }
        title="Ocultar Registro"
        description="Los registros ocultados solo serán recuperados por el Administrador."
        confirmText="Ocultar registro"
        cancelText="Cancelar"
        icon={<ErrorOutlineIcon className={classes.errorIcon} />}
        classes={{
          dialogTitle: classes.dialogTitle,
          dialogContent: classes.dialogContent,
          dialogButtons: classes.dialogButtons,
          confirmButton: classes.greenButton,
          cancelButton: classes.greenButton,
          iconWrapper: classes.iconWrapper,
        }}
      />
    </div>
  );
};

export default Rendiciones;
